import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import {
  CreateDetergentHistoryComponentForm,
  CreateDetergentHistoryPageHeader,
} from '@/components/pages/DetergentHistories/Create'
import { useDetergents } from '@/pages/Detergents/Detergent.hooks'

import { useCreateDetergentHistory } from './Create.hooks'

const CreateDetergentHistory = () => {
  const { id } = useParams()
  const { createDetergentHistory, loading } = useCreateDetergentHistory()
  const { getDetergentDetail, getDetergentDetailResponse } = useDetergents()

  useEffect(() => {
    if (id) {
      getDetergentDetail(Number(id))
    }
  }, [getDetergentDetail, id])

  return (
    <>
      <CreateDetergentHistoryPageHeader />
      <CreateDetergentHistoryComponentForm
        {...{ loading, getDetergentDetailResponse }}
        onSubmit={createDetergentHistory}
      />
    </>
  )
}

CreateDetergentHistory.displayName = 'CreateDetergentHistory'
export default CreateDetergentHistory
